/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import { myTownshipLink, navLinks } from "components/header/constants";
import { ReactComponent as GlobeIcon } from "cms/assets/icons/globe-outline.svg";
import { ReactComponent as UserIcon } from "cms/assets/icons/user.svg";
import { ReactComponent as ChevronDown } from "cms/assets/icons/chevron-down.svg";

const LangleyTopBar = () => {

    return (
        <div className='langley-top-bar'>
            {navLinks && navLinks.map((navLink, idx) => {
                const linkText = navLink?.title ?? "";
                const url = navLink?.url ?? "";
                return (
                    <a href={url} key={`nav-link-${idx}`}>{linkText}</a>
                );
            })}
            <a className='my-township-link' href={myTownshipLink?.url}>
                <UserIcon />
                {myTownshipLink?.title}
            </a>
            <div className='language-dropdown'>
                <GlobeIcon className='globe-icon' />
                Language
                <ChevronDown className='chevron' />
            </div>
        </div>
    );
};

export { LangleyTopBar };
